import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
export const NEWS = "news";
class NewsRequestMapper {
    formatRequest(reqType, subscribe) {
        const subReq = {
            request: {
                streaming_type: reqType,
                data: {},
                formFactor: "W",
                response_format: "json",
                request_type: subscribe ? "subscribe" : "unsubscribe",
                appID: urlConfig.appid,
            },
            echo: {},
        };
        return JSON.stringify(subReq);
    }
}
export default NewsRequestMapper;
